import * as options from "./options";
import * as api from "@/api/api";
import * as directives from "./directives";
import * as foreign from "./foreign"
import QRCode from 'qrcodejs2'
import utils from "@/util/utils";

var md5 = require("md5");
var _ = require("lodash");
export default {
    install(Vue) {
        Vue.prototype.$utils = utils
        Vue.prototype.$foreign = foreign
        Vue.prototype.$optionsData = options;
        Vue.prototype.$api = api;
        Vue.prototype.$md5 = md5;
        Vue.prototype.$_ = _;
        Vue.prototype.$qrCode = QRCode;
        for (let key in directives) {
            Vue.directive(key, directives[key]);
        }
    },
};
